/**
 * Created by michael on 8/21/2016.
 */

import _ from 'lodash';
import { getNormalizedDesktopElements } from 'crazyEditor/redux/modules/element/elementSelectors';
import { store } from 'crazyEditor/redux/store';
import {getFontSize} from 'crazyEditor/core/elements/utils/commonElementMethods';

export function getIsBold(element) {
  return _.get(element, 'data.compProps.fontWeight') === 'bold';
}

export function getToggleBold(element) {
  return {
    data: {
      compProps: {
        fontWeight: getIsBold(element) ? null : 'bold',
      }
    }
  };
}

export function getIsUnderline(element) {
  return _.get(element, 'data.compProps.textDecoration') === 'underline';
}

export function getToggleUnderline(element) {
  return {
    data: {
      compProps: {
        textDecoration: getIsUnderline(element) ? null : 'underline',
      }
    }
  };
}

export function getIsItalic(element) {
  return _.get(element, 'data.compProps.fontStyle') === 'italic';
}

export function getToggleItalic(element) {
  return {
    data: {
      compProps: {
        fontStyle: getIsItalic(element) ? null : 'italic',
      }
    }
  };
}

export function getTextAlign(element) {
  return _.get(element, 'data.compProps.textAlign');
}

export function getTextAlignSetter(textAlign) {
  return {
    data: {
      compProps: {
        textAlign,
      }
    }
  };
}

export function getFontSizeSetter(fontSize) {
  return {
    data: {
      compProps: {
        fontSize,
      }
    }
  };
}

export function getFontFamilySetter(fontFamily) {
  return {
    data: {
      compProps: {
        fontFamily,
      }
    }
  };
}

export function getFontSizeSetterByPercentFromDesktopElement(element, percent) {
  const desktopElements = getNormalizedDesktopElements(store.getState());
  const desktopElement = desktopElements[element.desktopId];
  const fontSize = percent / 100 * parseInt(getFontSize(desktopElement), 10);
  return {
    data: {
      compProps: {
        fontSize,
      },
      fontSizeInPercentFromDesktop: percent,
    }
  };
}

export function getFontSizeInPercentFromDesktop(element) {
  const desktopElements = getNormalizedDesktopElements(store.getState());
  const desktopElement = desktopElements[element.desktopId];
  const desktopElementFontSize = getFontSize(desktopElement);
  const elementFontSize = getFontSize(element);
  return Math.round(elementFontSize / desktopElementFontSize * 100);
}
